import {
    ChangeDetectorRef,
    Directive,
    Optional,
    Self,
    ElementRef,
    HostListener,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { PickerAbstract } from './picker';

@Directive({
    selector: 'anj-input[anjDatePicker]',
    exportAs: 'anjDatepickerInput'
})
export class DatePickerDirective extends PickerAbstract {
    @HostListener('anjBlur')
    onAnjBlur() {
        this.onTouch();
    }

    @HostListener('anjDateChange', ['$event'])
    public onAnjDateChange(event: any) {
        this.changeHandler(event.detail);
    }

    constructor(_element: ElementRef,
                changeRef: ChangeDetectorRef,
                @Optional() @Self() ngControl?: NgControl
    ) {
        super(_element, changeRef, ngControl);

        this.pickerSelector = 'anj-date-picker';
    }
}
